import { createSelector } from "@ngrx/store";
import * as fromFeature from "../reducers";
import * as fromTeacherMetrics from "../reducers/teacher-metrics.reducer";

// get teacherMetrics state
export const getTeacherMetricsState = createSelector(
    fromFeature.getCoursesModuleState,
    (state: fromFeature.CoursesState) => state.teacherMetrics
);

// get teacherMetrics
export const getTeacherMetrics = createSelector(
    getTeacherMetricsState,
    fromTeacherMetrics.getTeacherMetrics
);

export const getTeacherMetricsLoading = createSelector(
    getTeacherMetricsState,
    fromTeacherMetrics.getTeacherMetricsLoading
);
